import { useCallback, useRef, useState } from 'react';

import { SupportMessageDirection } from '@app/api/Support';
import { parseSupportMessageEvent } from '@app/api/Support/supportMessageEvent';

/**
 * Счётчик ответов поддержки, пришедших по WS, пока окно чата закрыто.
 * Только на фронте: у бэкенда нет признака прочтения, поэтому счётчик живёт
 * до перезагрузки страницы и сбрасывается при открытии чата.
 */
export const useSupportChatUnread = () => {
  // Считаем по Id — одно и то же сообщение может прийти повторно
  const unreadMessageIdsRef = useRef(new Set<number>());

  const [unreadCount, setUnreadCount] = useState(0);

  const handleClosedChatMessageEvent = useCallback((raw: unknown) => {
    const incoming = parseSupportMessageEvent(raw);

    // Свои сообщения (in — например, из другой вкладки) не считаем
    incoming?.Messages?.forEach(({ Id, Direction }) => {
      if (Direction === SupportMessageDirection.Out) {
        unreadMessageIdsRef.current.add(Id);
      }
    });

    setUnreadCount(unreadMessageIdsRef.current.size);
  }, []);

  const markMessagesAsRead = useCallback(() => {
    unreadMessageIdsRef.current.clear();
    setUnreadCount(0);
  }, []);

  return { unreadCount, handleClosedChatMessageEvent, markMessagesAsRead };
};
